export const colors = {
  primary: ["#53A2BE", "#B23A48"],
  primaryLight: ["#C4DFE9", "#DFAEB4"],
  primaryDark: ["#16323C", "#461220"],
  light: ["#F0F7F9", "#F9F1F3"],
};
